import { formatNumber } from 'libphonenumber-js';

const PhoneNumberFormat = (phoneNumber) => {

  if (phoneNumber) {
    let phone = `+${phoneNumber}`;
    const phoneNumberFormat = formatNumber( phone , 'National');
    const displayNumber = `${phoneNumberFormat.replace("+", '')}`;
    return displayNumber;
  }
  return ""
}
export default PhoneNumberFormat;



// WEBPACK FOOTER //
// ./src/lib/phoneNumber/PhoneNumberFormat.js